import * as _ from "lodash";
import base_ds from "@/services/base_datasource_service";
import { BaseEntity, IResponseResult } from "./base_types";

export const filial_route_ns = `dicts/heat_carrier`;

export class HeatCarrier extends BaseEntity {
  order: number = 0;
  code: string = "";
  name: string = "";
  is_steam: boolean = true;
}

class HeatCarrierService {
  public data_source = base_ds.getBaseDataSource(filial_route_ns);
  public crud = base_ds.getBaseCrud(filial_route_ns);

  public local: HeatCarrier[] = [];

  public async storeLocal() {
    const resp = await this.get();
    this.local  = resp?.data || [];
  }

  public async get(): Promise<IResponseResult<HeatCarrier[]>> {
    const response: any = await this.crud.get();
    if (response.data) {
      return { data: (response.data as HeatCarrier[]) };
    }
      return { data: null, message: ''};
  }

}

export default new HeatCarrierService();
